import { MODAL_ACTIONS } from 'food-benefit.module/common/domain/constants';

class ManagerAcceptAllController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.cancel = MODAL_ACTIONS.CANCEL;
    this.approveAll = MODAL_ACTIONS.APPROVE_ALL;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  actionButton(action) {
    this.setAction(this.EventEmitter({ status: action }));
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SEND'
      },
      {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }
}

export default ManagerAcceptAllController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/managerAcceptAll/managerAcceptAll.controller.js